import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";

import { useClaimContext } from "../../contexts/ClaimContext";

import Form from "./EditForm";

export default function Table({ role, editIcon, deleteIcon }) {
  const { dispatch, actions, state } = useClaimContext();
  const [show, setShow] = useState(false);
  const [editClaim, setEditClaim] = useState(null);
  const [filteredMemberName, setFilteredMemberName] = useState("");

  const filteredItems =
    state.claims &&
    Object.values(state.claims).filter((item) => {
      let available = false;
      if (
        item.attributes.member
          .toLowerCase()
          .includes(filteredMemberName.toLowerCase()) ||
        item.attributes.work_email
          .toLowerCase()
          .includes(filteredMemberName.toLowerCase())
      )
        available = true;

      return available;
    });

  let columns = [
    {
      name: "Name",
      selector: "attributes.member",
      sortable: true,
    },
    {
      name: "Work Email",
      selector: "attributes.work_email",
      sortable: true,
    },
    {
      name: "Team",
      selector: "attributes.team",
      sortable: true,
    },
    {
      name: "Program",
      selector: "attributes.program.title",
      sortable: true,
    },
    {
      name: "Completed",
      selector: "attributes.program.last_session_completed_date",
      sortable: true,
    },
    {
      name: "Claim Date",
      selector: "attributes.date",
      sortable: true,
    },
  ];

  if (role == "team_lead") {
    columns.push({
      name: "Actions",
      width: "100px",
      cell: (row) => <div></div>,
      sortable: false,
      cell: (row) => (
        <div>
          {row.attributes.possible_change && (
            <>
              <a
                data-toggle="tooltip"
                title="Edit Claim"
                onClick={(e) => editItem(e, row)}
                className="mr10"
              >
                <img src={editIcon} />
              </a>
              <a
                data-toggle="tooltip"
                title="Delete Claim"
                onClick={(e) => deleteItem(e, row)}
              >
                <img src={deleteIcon} />
              </a>
            </>
          )}
        </div>
      ),
    });
  }

  if (role == "super_admin") {
    columns = [
      {
        name: "Enterprise",
        selector: "attributes.enterprise",
        sortable: true,
      },
      {
        name: "Manager",
        selector: "attributes.manager",
        sortable: true,
      },
      ...columns,
    ];
  }

  const closeForm = () => setShow(false);
  const openForm = () => setShow(true);

  const deleteItem = (e, row) => {
    const target = e.currentTarget;

    swal(
      {
        title: "",
        text: "Do you want to delete this claim?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          target.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.removeClaim(dispatch, row, function () {
            swal({
              title: "Claim Deleted!",
              text: "Our claim's specialist will reach out to you shortly.",
              html: true,
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Close",
              closeOnConfirm: true,
            });
          });
        }
      }
    );
  };

  const editItem = (e, row) => {
    document.querySelectorAll(".tooltip").forEach((el) => {
      el.remove();
    });

    setEditClaim(row);
    openForm();
  };

  useEffect(() => {
    actions.loadClaims(dispatch);
  }, []);

  return (
    <>
      <div className="invite_search">
        <form
          className="inviteSearch_form manager-member-keyword"
          action="javascript:void(0);"
        >
          <input
            type="text"
            placeholder="Search Member"
            value={filteredMemberName}
            onChange={(e) => setFilteredMemberName(e.target.value)}
          />
        </form>
      </div>

      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={filteredItems || []}
          noDataComponent={
            <div className="mt20">
              {state.claims == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
        <Modal
          className="student inmodal auto without-overflow"
          show={show}
          onHide={closeForm}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Claim</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form closeForm={closeForm} row={editClaim} />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
